// Map Styles
export var stateLine = {
    "id": "stateLines",
    "source": "counties",
    "type": "line",
    "minzoom": 0,
    "maxzoom": 22,
    "layout": {
        "visibility": "visible"
    },
    "paint": {
        "line-blur": 1,
        "line-color": "#03493a",
        "line-width": 4,
        "line-opacity": 1
    }
};
export var stateFill = {
    "id": "stateFills",
    "type": "fill",
    "source": "counties",
    "paint": {
        "fill-color": [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            "hsla(158, 84%, 35%, 0.9)",
            10,
            "hsla(158, 84%, 35%, 0.9)",
            12,
            "hsla(158, 84%, 35%, 0.3)"
        ],
        "fill-opacity": 0,
    }
};
export var countyLine = {
    "id": "countyLines",
    "source": "counties",
    "type": "line",
    "minzoom": 0,
    "maxzoom": 22,
    "layout": {
        "visibility": "visible"
    },
    "paint": {
        "line-blur": 1,
        "line-color": "#03493a",
        "line-width": [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            6,
            1,
            9,
            4
        ],
        "line-opacity": 1
    }
};
export var countyFill = {
    "id": "countyFills",
    "type": "fill",
    "source": "counties",
    "paint": {
        "fill-color": [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            "hsla(158, 84%, 35%, 0.9)",
            10,
            "hsla(158, 84%, 35%, 0.9)",
            12,
            "hsla(158, 84%, 35%, 0.3)"
        ],
        "fill-opacity": 0,
    }
};
export var countyHover = {
    "id": "countyHover",
    "type": "fill",
    "source": "counties",
    "paint": {
        "fill-color": "#001c38",
        "fill-opacity": 0,
    }
};
export var cityLine = {
    "id": "cityLines",
    "source": "cities",
    "type": "line",
    "minzoom": 0,
    "maxzoom": 22,
    "layout": {
        "visibility": "visible"
    },
    "paint": {
        "line-blur": 1,
        "line-color": "#007D61",
        "line-width": [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            1,
            6,
            1,
            9,
            2
        ],
        "line-opacity": 1
    }
};
export var cityFill = {
    "id": "cityFills",
    "type": "fill",
    "source": "cities",
    "paint": {
        "fill-color": [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            "hsla(158, 84%, 35%, 0.8)",
            10,
            "hsla(158, 84%, 35%, 0.8)",
            12,
            "hsla(158, 84%, 35%, 0.3)"
        ],
        "fill-opacity": 1,
    }
};
export var cityHover = {
    "id": "cityHover",
    "type": "fill",
    "source": "cities",
    "paint": {
        "fill-color": "#007D61",
        "fill-opacity": 0.5,
    }
};
export var clusterLayer = {
    id: 'clusters',
    type: 'circle',
    source: 'resources',
    paint: {
        'circle-color': ['step', ['get', 'point_count'], '#0E2A40', 100, '#0E2A40', 750, '#0E2A40'],
        'circle-radius': ['step', ['get', 'point_count'], 10, 10, 14, 100, 16]
    }
};
export var clusterCountLayer = {
    id: 'clusterCount',
    type: 'symbol',
    source: 'resources',
    paint: {
        'text-color': '#ffffff'
    },
    layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 14
    }
};
export var unclusteredPointLayer = {
    id: 'unclusteredPoints',
    type: 'circle',
    source: 'resources',
    paint: {
        'circle-color': '#0E2A40',
        'circle-radius': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            4,
            9,
            4,
            10,
            6,
            15,
            10
        ],
        'circle-stroke-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            0,
            9,
            0,
            10,
            1,
            15,
            1
        ],
        'circle-stroke-color': '#ffffff'
    }
};
export var allPointLayer = {
    id: 'allPoints',
    type: 'circle',
    source: 'resources',
    beforeId: 'Other border',
    paint: {
        'circle-color': '#0E2A40',
        'circle-radius': [
            "interpolate",
            ["linear"],
            ["zoom"],
            4,
            1,
            9,
            4,
            10,
            6,
            15,
            10
        ],
        'circle-stroke-width': [
            "interpolate",
            ["linear"],
            ["zoom"],
            0,
            0,
            9,
            0,
            10,
            1,
            15,
            1
        ],
        'circle-stroke-color': '#ffffff'
    }
};
